import React, { ReactElement } from 'react'
import { MdLogout } from 'react-icons/md'
import { useAuthenticator } from '@aws-amplify/ui-react'
import './LoginStyles.scss'

export default function LogoutButton({
  setLoginStatus, // Destructure the setLoginStatus function from props
}: {
  setLoginStatus: React.Dispatch<React.SetStateAction<boolean>>
}): ReactElement {
  const { signOut } = useAuthenticator()

  return (
    <div className="logoutButton">
      <button
        onClick={() => {
          try {
            signOut()
            setTimeout(() => {
              // Manually delay the logout status update
              setLoginStatus(false)
            }, 1000)
          } catch (error) {
            console.error('Error signing out:', error)
          }
        }}
        type="button"
      >
        Logout <MdLogout />
      </button>
    </div>
  )
}
